export const _TIMELINE_FILTER_ERROR = 'Please select at least one filter.';
export const validate = (type, selects) => {
    let newErrors = {};

    if (type === 'Appointments') {
        if (Object.keys(selects).length < 1)
            return {
                ...newErrors,
                button: {
                    error: true,
                    message: _TIMELINE_FILTER_ERROR
                }
            };
        return newErrors;
    }

    return newErrors;
};
